// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"Login","138":"profile","594":"demo"}[chunkId] + "." + {"94":"69b2ac41","138":"b2a2cdce","594":"551c1349"}[chunkId] + ".css";
};